import { usePrevious } from "@react-hookz/web";
import { DatePickerDate } from "../../types";

/**
 * If the date is the same as the previous date, return the previous date. Otherwise, return the new
 * date.
 */
export const useMemoizedDatePickerDate = (nextDate: DatePickerDate | null): DatePickerDate | null => {
    const memoizedDate = usePrevious(nextDate) || null;
    // Initially, we'll immediately return the nextDate since the usePrevious hook returns undefined
    // on the first render.
    if (!memoizedDate) {
        return nextDate || null;
    }

    // If we have a nextDate and it's the same as the memoizedDate, return the memoizedDate.
    if (nextDate && datePickerDateIsEqual(memoizedDate, nextDate)) {
        return memoizedDate;
    }

    // If we get here, nextDate is a new date or is falsy.
    return nextDate || null;
};

const datePickerDateIsEqual = (a: DatePickerDate, b: DatePickerDate): boolean => {
    return a.year === b.year && a.month === b.month && a.day === b.day;
};
